var exports = {
  "k": "x93eb46d8--e5f4bf--container",
  "x": "x93eb46d8--e5f4bf--button",
};

module.exports = exports;
